import React from 'react';

const Landing = () => {
  return (
    <div className="landing">
      <div className="container">
        <div className="text">
        
          <h1>Welcome, To Mohamed ABi Portfolio</h1>
        <div className="wrapper">
          <div className="static-txt">I'm </div>
              <ul className="dynamic-txts">
                  <li><span>Designer</span></li>
                  <li><span>Developer</span></li>
                  <li><span>Freelancer</span></li>
              </ul>
          </div>
          <p> Explore my work, collaborations, projects, websitesand  certifications. Get to know my expertise in web development and design. Discover creativity and technical excellence in one place.</p>
        </div>
        <div className="image">
          <img src="imgs/med.jpg" alt="" />
        </div>
      </div>
      <a href="#pricing" className="go-down">
        <i className="fas fa-angle-double-down fa-2x"></i>
      </a>
    </div>
  );
};

export default Landing;
